import { createEmptyOption, createSelectContent } from './SelectList.Helpers';
import React from 'react';
import SelectOption from '../../../infrastructure/types/SelectOption';

interface SelectListProps {
    options: SelectOption[];
    value: string;
    onChange: (value: string, e: React.ChangeEvent<HTMLElement>, text: string, number?: number) => void;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
    disabled?: boolean;
    includeEmptyOption?: boolean;
}

class SelectList extends React.Component<SelectListProps> {
    constructor(props: SelectListProps) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e: React.ChangeEvent<HTMLSelectElement>): void {

        let text = this.props.options.find(x => x.value === e.target.value)?.text || '';

        let number = this.props.options.find(x => x.value === e.target.value)?.number || 0;

        this.props.onChange(e.target.value, e, text, number);
    }

    render(): JSX.Element {

        let prependOptions = this.props.includeEmptyOption ? [createEmptyOption()] : [];

        return (
            <select
                onChange={this.onChange}
                onClick={this.props.onClick && this.props.onClick}
                value={this.props.value}
                className={this.props.className}
                disabled={this.props.disabled}>
                {prependOptions.concat(createSelectContent(this.props.options))}
            </select>
        );
    }
}

export default SelectList;